import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import { useNotification } from '../../context/NotificationContext'; // <-- 1. IMPORT

function Signup() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    re_password: '',
  });
  const navigate = useNavigate();

  // --- 2. GET THE FUNCTION AT THE TOP ---
  const { showNotification } = useNotification();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/v1/users/', formData);

      // --- 3. REPLACE alert() with showNotification() ---
      showNotification('Account created! You can now log in.');

      navigate('/login');

    } catch (err) {
      if (err.response?.data) {
        console.log('Server error response:', err.response.data);
        const errors = err.response.data;
        const firstField = Object.keys(errors)[0];
        const message = errors[firstField][0];

        // --- 3. REPLACE alert() with showNotification() ---
        showNotification(`Signup failed: ${firstField}: ${message}`, 'error');

      } else {
        // --- 3. REPLACE alert() with showNotification() ---
        showNotification('Signup failed: ' + err.message, 'error');
      }
    }
  };

  return (
    <div className='signup-form-wrapper'>
      <div className='signup-form-card'>
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit}>
          <input
            type='email'
            name='email'
            placeholder='Email'
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type='password'
            name='password'
            placeholder='Password'
            value={formData.password}
            onChange={handleChange}
            required
          />
          <input
            type='password'
            name='re_password'
            placeholder='Confirm Password'
            value={formData.re_password}
            onChange={handleChange}
            required
          />
          <button type='submit'>Create Account</button>
        </form>
        <p className='links'>
          Already registered? <a href='/login'>Log in</a>
        </p>
      </div>
    </div>
  );
}

export default Signup;
